import { getDictType, addDictType, updateDictType, deleteDictType, refreshData, getDictValue, addDictValue, updateDictValue, deleteDictValue, selectRepairType, selectMalfunctionType, selectExternalType, selectHomePageUrl, selectCarOperationType, selectTonnageType } from "../../api/config/modules/DictionaryManaged";

const state = {
  getDictType: {},
  addDictType: {},
  updateDictType: {},
  deleteDictType: {},
  refreshData: {},
  getDictValue: {},
  addDictValue: {},
  updateDictValue: {},
  deleteDictValue: {},
  selectRepairType: {},
  selectMalfunctionType: {},
  selectExternalType: {},
  selectHomePageUrl: {},
  selectCarOperationType: {},
  selectTonnageType: {}
};

const mutations = {
  SET_GETDICTTYPE: (state, getDictType) => {
    state.getDictType = getDictType;
  },
  SET_ADDDICTTYPE: (state, addDictType) => {
    state.addDictType = addDictType;
  },
  SET_UPDATEDICTTYPE: (state, updateDictType) => {
    state.updateDictType = updateDictType;
  },
  SET_DELETEDICTTYPE: (state, deleteDictType) => {
    state.deleteDictType = deleteDictType;
  },
  SET_REFRESHDATA: (state, refreshData) => {
    state.refreshData = refreshData;
  },
  SET_GETDICTVALUE: (state, getDictValue) => {
    state.getDictValue = getDictValue;
  },
  SET_ADDDICTVALUE: (state, addDictValue) => {
    state.addDictValue = addDictValue;
  },
  SET_UPDATEDICTVALUE: (state, updateDictValue) => {
    state.updateDictValue = updateDictValue;
  },
  SET_DELETEDICTVALUE: (state, deleteDictValue) => {
    state.deleteDictValue = deleteDictValue;
  },
  SET_SELECTREPAIRTYPE: (state, selectRepairType) => {
    state.selectRepairType = selectRepairType;
  },
  SET_SELECTMALFUNCTIONTYPE: (state, selectMalfunctionType) => {
    state.selectMalfunctionType = selectMalfunctionType;
  },
  SET_SELECTEXTERNALTYPE: (state, selectExternalType) => {
    state.selectExternalType = selectExternalType;
  },
  SET_SELECTHOMEPAGEURL: (state, selectHomePageUrl) => {
    state.selectHomePageUrl = selectHomePageUrl;
  },
  SET_SELECTCAROPERATIONTYPE: (state, selectCarOperationType) => {
    state.selectCarOperationType = selectCarOperationType;
  },
  SET_SELECTTONNAGETYPE: (state, selectTonnageType) => {
    state.selectTonnageType = selectTonnageType;
  },
};

const actions = {
  GET_GETDICTTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getDictType(data)
        .then((res) => {
          commit("SET_GETDICTTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ADDDICTTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      addDictType(data)
        .then((res) => {
          commit("SET_ADDDICTTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEDICTTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateDictType(data)
        .then((res) => {
          commit("SET_UPDATEDICTTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEDICTTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteDictType(data)
        .then((res) => {
          commit("SET_DELETEDICTTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_REFRESHDATA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      refreshData(data)
        .then((res) => {
          commit("SET_REFRESHDATA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETDICTVALUE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getDictValue(data)
        .then((res) => {
          commit("SET_GETDICTVALUE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ADDDICTVALUE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      addDictValue(data)
        .then((res) => {
          commit("SET_ADDDICTVALUE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEDICTVALUE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateDictValue(data)
        .then((res) => {
          commit("SET_UPDATEDICTVALUE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEDICTVALUE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteDictValue(data)
        .then((res) => {
          commit("SET_DELETEDICTVALUE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTREPAIRTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectRepairType(data)
        .then((res) => {
          commit("SET_SELECTREPAIRTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTMALFUNCTIONTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectMalfunctionType(data)
        .then((res) => {
          commit("SET_SELECTMALFUNCTIONTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTEXTERNALTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectExternalType(data)
        .then((res) => {
          commit("SET_SELECTEXTERNALTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTHOMEPAGEURL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectHomePageUrl(data)
        .then((res) => {
          commit("SET_SELECTHOMEPAGEURL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCAROPERATIONTYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarOperationType(data)
        .then((res) => {
          commit("SET_SELECTCAROPERATIONTYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTTONNAGETYPE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectTonnageType(data)
        .then((res) => {
          commit("SET_SELECTTONNAGETYPE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
